import { FC, useMemo } from 'react';
import { ApplicationClosed } from './templates/ApplicationClosed';
import { Unknown } from './templates/Unknown';

export type ErrorKind = 'unknown' | 'application-closed';

export type ErrorToastProps = {
  error: ErrorKind | null;
  onClose: () => void;
};

export const ErrorToast = (props: ErrorToastProps) => {
  const { error } = props;

  const errorMap: Record<ErrorKind, FC<ErrorToastProps>> = useMemo(
    () => ({
      unknown: Unknown,
      'application-closed': ApplicationClosed,
    }),
    []
  );

  const ErrorToast = useMemo(
    () => (error ? errorMap[error] : Unknown),
    [error, errorMap]
  );

  return <ErrorToast {...props} />;
};
